<template>
	<div>
		<div class="contentShow" ref="content" v-html="content"></div>
		<div class="image-preview">
			<el-image ref="imagePreview" v-for="(url, index) in imageUrls" :key="index"
				style="width: 100px; height: 100px; margin-right: 10px;" :src="url" :preview-src-list="imageUrls"
				@error="onImageError(index)" @load="onImageLoad(index)" @preview="onImagePreview(index)" lazy />
		</div>
	</div>
</template>

<script>
	export default {
		props: {
			content: {
				type: String,
				required: true
			}
		},
		data() {
			return {
				imageUrls: [],
			};
		},
		watch: {
			content(newContent) {
				this.extractImages(newContent);
			}
		},
		mounted() {
			this.extractImages(this.content);
		},
		methods: {
			extractImages(content) {
				this.$nextTick(() => {
					const contentElement = this.$refs.content;
					if (contentElement) {
						const imgTags = contentElement.querySelectorAll('img');

						this.imageUrls = Array.from(imgTags).map(img => img.src);

						// 给每个图片标签添加点击事件
						imgTags.forEach((img, index) => {
							img.addEventListener('click', () => {
								this.previewImage(index);
							});
						});
					}
				});
			},
			previewImage(index) {
				const imageInstance = this.$refs.imagePreview[index];
				if (imageInstance) {
					imageInstance.$el.children[0].click();
				} else {
					this.$message({
						message: '图片加载中，请稍后...',
						type: 'warning'
					});
				}
			},
			onImageLoad(index) {},
			onImageError(index) {},
			onImagePreview(index) {}
		}
	};
</script>

<style scoped>
	.contentShow {
		font-size: 16px;
	}
	

	.image-preview {
		opacity: 0;
	}

	.el-image {
		cursor: pointer;
	}

	::v-deep.contentShow img {
		max-width: 100%;
		cursor: zoom-in;
	}

	@media screen and (min-width: 1000px) {
		.contentShow {
			padding: 30px 0 50px 0;
			color: #666;
			line-height: 32px;
			font-size: 14px;
		}
	}

	@media screen and (max-width: 999px) {
		.contentShow {
			padding: 4vw 0;
			color: #666;
			line-height: 6.4vw;
			font-size: 3.73333vw;
		}
	}
</style>